import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatDialogModule, TranslocoModule],
    selector: 'app-cancel-order',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
    action: string;
    local_data: any;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.local_data = { ...data };
        this.action = this.local_data.action;
    }

    ngOnInit() {}

    onClick(value: boolean) {
        this.dialogRef.close(value);
    }
}
